import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from 'react-bootstrap'

const Product = ({ product }) => {
  return (
    <Card className='my-3 p-3 rounded'>
      <Link to={`/product/${product.product_id}`}>
        <Card.Img src={product.image[0]['url']} variant='top' />
      </Link>

      <Card.Body>
        <Link to={`/product/${product.product_id}`}>
          <Card.Title as='div'>
            <strong>{product.name}</strong>
          </Card.Title>
        </Link>
      </Card.Body>
    </Card>
  )
}

export default Product
